<template>
  <div class="pt-5">
    <p>
      {{ company }}<br>
      <span class="pre-formatted">{{ displayName }}</span><br>
      <span class="pre-formatted">{{ fullAddress }}</span><br>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'Address',
    
    props: {
      address: Object,
    },

    computed: {
      company() {
        if (this.address.company) {
          return this.address.company
        }

        return ''
      },
      displayName() {
        let displayName = ''
        if (this.address.firstName) {
          displayName += this.address.firstName
        }

        if (this.address.lastName) {
          displayName += ' ' + this.address.lastName
        }

        return displayName
      },
      fullAddress() {
        let fullAddress = ''

        if (this.address.address1) {
          fullAddress += this.address.address1
        }

        if (this.address.address2) {
          fullAddress += '\n' + this.address.address2
        }

        if (this.address.address3) {
          fullAddress += '\n' + this.address.address3
        }

        fullAddress += '\n' + `${this.address.zipcode} ${this.address.city} (${this.address.country})`

        return fullAddress
      },
    }
  }
</script>

<style scoped>
  .pre-formatted {
    white-space: pre;
  }
</style>